import React, { useEffect, useState } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableFooter,
	TableHead,
	TableRow,
	Paper,
	TextField,
	Box,
} from "@mui/material";
import "../../../css/empresa_uno/ventas.css";
import pdf from "../../../images/pdf.png";
import buscar_azul from "../../../images/search_azul.png";
import { PDFDownloadLink } from "@react-pdf/renderer";
import GenerateReporteCaja from "../../../Reports/GenerateReporteCaja";
import { ApiService } from "../../ApiService";
import { useParams } from "react-router-dom";
import { useCompanyAssigned } from "../../CompanyAssignedContext";
import LupaIcon from "../../../svg/lupaIcon";
import Button from "@mui/material/Button";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import SearchCompany from "../../../pages/empresa_uno/SearchCompany";

export const VreporteCaja = ({ selectedSucursal, currentUserPermissions, permisos, convertPrice = (() => { }) }) => {
	const { nit, sub_direc } = useParams();

	const [sucursales, setSucursales] = useState([]);
	const [objCaja, setObjCaja] = useState([]);

	const [fechaIni, setFechaIni] = useState(null);
	const [fechaFin, setFechaFin] = useState(null);

	const fech_ListCaja = async (key_branch, fecha1, fecha2) => {
		const url = `api/company/cash/reports?start_date=${fecha1}&end_date=${fecha2}&key_branch=${key_branch}`;
		const options = { method: "GET" };

		const request_caja = await ApiService.fetchData(url, options);

		if (!request_caja) {
			alert("Error al cargar los datos de ventas del día");
			return;
		}

		setObjCaja(request_caja);
	};

	useEffect(() => {
		const current_suc = selectedSucursal;
		const comp_date = new Date();
		const currentDate = `${comp_date.getFullYear()}-${String(comp_date.getMonth() + 1).padStart(2, "0")}-${String(comp_date.getDate()).padStart(2, "0")}`;

		if (fechaIni == null && fechaFin == null) {
			setFechaFin(currentDate);
			setFechaIni(currentDate);
		}

		setSucursales(current_suc);
		fech_ListCaja(current_suc, fechaIni || currentDate, fechaFin || currentDate);
	}, [selectedSucursal]);

	function handleChange(e, comp) {
		comp == 1 ? setFechaIni(e) : setFechaFin(e);

		fech_ListCaja(sucursales, comp == 1 ? e : fechaIni, comp == 2 ? e : fechaFin);
	}

	const totalPc =
		objCaja && objCaja.reduce((acc, row) => (parseFloat(acc) + parseFloat(row.purchase_price)).toFixed(2), 0);
	const totalB =
		objCaja &&
		objCaja.reduce(
			(acc, row) => (parseFloat(acc) + (parseFloat(row.price) - parseFloat(row.purchase_price))).toFixed(2),
			0
		);
	const totalGeneral =
		objCaja && objCaja.reduce((acc, row) => (parseFloat(acc) + parseFloat(row.price)).toFixed(2), 0);
	const totalEfectivoEntrada =
		objCaja &&
		objCaja.reduce(
			(acc, row) =>
				(parseFloat(acc) + (row.type == 1 && row.pay == "efectivo" ? parseFloat(row.price) : 0)).toFixed(2),
			0
		);
	const totalEfectivoSalida =
		objCaja &&
		objCaja.reduce(
			(acc, row) =>
				(parseFloat(acc) + (row.type == 0 && row.pay == "efectivo" ? parseFloat(row.price) : 0)).toFixed(2),
			0
		);
	const totalQrEntrada =
		objCaja &&
		objCaja.reduce(
			(acc, row) => (parseFloat(acc) + (row.type == 1 && row.pay == "qr" ? parseFloat(row.price) : 0)).toFixed(2),
			0
		);
	const totalQrSalida =
		objCaja &&
		objCaja.reduce(
			(acc, row) => (parseFloat(acc) + (row.type == 0 && row.pay == "qr" ? parseFloat(row.price) : 0)).toFixed(2),
			0
		);
	const totalDeboE =
		objCaja &&
		objCaja.reduce(
			(acc, row) => (parseFloat(acc) + parseFloat((row.type == 1 ? "" : "-") + row.price)).toFixed(2),
			0
		);

	return (
		<div>
			<div className="functionality-container">
				<div className="header-reports">
					<h2 style={{ color: 'var(--theme-company)' }}>Reporte de Caja</h2>

					<div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
						<TextField
							label="Fecha Inicial"
							type="date"
							value={fechaIni}
							onChange={(e) => handleChange(e.target.value, 1)}
							size="small"
							sx={{ width: "150px" }}
							InputLabelProps={{
								shrink: true,
							}}
						/>

						<TextField
							label="Fecha Fin"
							type="date"
							value={fechaFin}
							onChange={(e) => handleChange(e.target.value, 2)}
							size="small"
							sx={{ width: "150px" }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</div>

					<div>
						<SearchCompany theme={'var(--theme-company)'} placeholder="reporte de caja" />

						<div>
							<PDFDownloadLink document={<GenerateReporteCaja />} fileName="ReporteCaja.pdf">
								{({ loading, url, error }) => (
									<Button
										variant="contained"
										href={url}          // lo entrega el render-prop de PDFDownloadLink
										download            // fuerza la descarga
										// disabled={loading || !!error}
										disabled={true} //DESHABILITADO PORQUE AUN NO FUNCIONA
										startIcon={<PictureAsPdfIcon />}   // o tu propio <img … />
										sx={{ height: 41, textTransform: "none", background: 'var(--theme-company)' }}
									>
										{loading ? "Generando PDF…" : "PDF"}
									</Button>
								)}
							</PDFDownloadLink>
						</div>
					</div>
				</div>
			</div>

			<TableContainer component={Paper}>
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell
								align="center"
								rowSpan={2}
								sx={{
									backgroundColor: 'var(--theme-company)',
									color: "#fff",
									fontWeight: "bold",
									fontSize: "0.8rem",
									py: 0.5,
									px: 1,
								}}>
								Fecha
							</TableCell>
							<TableCell
								align="center"
								rowSpan={2}
								sx={{
									backgroundColor: 'var(--theme-company)',
									color: "#fff",
									fontWeight: "bold",
									fontSize: "0.8rem",
									py: 0.5,
									px: 1,
								}}>
								Código
							</TableCell>
							<TableCell
								align="center"
								rowSpan={2}
								sx={{
									backgroundColor: 'var(--theme-company)',
									color: "#fff",
									fontWeight: "bold",
									fontSize: "0.8rem",
									py: 0.5,
									px: 1,
								}}>
								Detalle
							</TableCell>
							{!permisos?.remove_costo && (
								<TableCell
									align="center"
									rowSpan={2}
									sx={{
										backgroundColor: 'var(--theme-company)',
										color: "#fff",
										fontWeight: "bold",
										fontSize: "0.8rem",
										py: 0.5,
										px: 1,
									}}>
									P.C.
								</TableCell>
							)}
							{!permisos?.remove_bene && (
								<TableCell
									align="center"
									rowSpan={2}
									sx={{
										backgroundColor: 'var(--theme-company)',
										color: "#fff",
										fontWeight: "bold",
										fontSize: "0.8rem",
										py: 0.5,
										px: 1,
									}}>
									B
								</TableCell>
							)}

							<TableCell
								align="center"
								rowSpan={2}
								sx={{
									backgroundColor: 'var(--theme-company)',
									color: "#fff",
									fontWeight: "bold",
									fontSize: "0.8rem",
									py: 0.5,
									px: 1,
								}}>
								Total
							</TableCell>
							<TableCell
								align="center"
								colSpan={2}
								sx={{
									backgroundColor: 'var(--theme-company)',
									color: "#fff",
									fontWeight: "bold",
									fontSize: "0.8rem",
									py: 0.5,
								}}>
								Efectivo
							</TableCell>
							<TableCell
								align="center"
								colSpan={2}
								sx={{
									backgroundColor: 'var(--theme-company)',
									color: "#fff",
									fontWeight: "bold",
									fontSize: "0.8rem",
									py: 0.5,
								}}>
								QR
							</TableCell>
							<TableCell
								align="center"
								rowSpan={2}
								sx={{
									backgroundColor: 'var(--theme-company)',
									color: "#fff",
									fontWeight: "bold",
									fontSize: "0.8rem",
									py: 0.5,
									px: 1,
								}}>
								Debo/E
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell
								align="center"
								sx={{
									backgroundColor: 'var(--theme-company)',
									color: "#fff",
									fontWeight: "bold",
									fontSize: "0.8rem",
									py: 0.3,
									px: 1,
								}}>
								Entrada
							</TableCell>
							<TableCell
								align="center"
								sx={{
									backgroundColor: 'var(--theme-company)',
									color: "#fff",
									fontWeight: "bold",
									fontSize: "0.8rem",
									py: 0.3,
									px: 1,
								}}>
								Salida
							</TableCell>
							<TableCell
								align="center"
								sx={{
									backgroundColor: 'var(--theme-company)',
									color: "#fff",
									fontWeight: "bold",
									fontSize: "0.8rem",
									py: 0.3,
									px: 1,
								}}>
								Entrada
							</TableCell>
							<TableCell
								align="center"
								sx={{
									backgroundColor: 'var(--theme-company)',
									color: "#fff",
									fontWeight: "bold",
									fontSize: "0.8rem",
									py: 0.3,
									px: 1,
								}}>
								Salida
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{objCaja &&
							objCaja.map((row, index) => (
								<TableRow key={index}>
									<TableCell align="center">{row.date_ope}</TableCell>
									<TableCell align="center">{row.code}</TableCell>
									<TableCell align="center">{row.detail}</TableCell>
									{!permisos?.remove_costo && (
										<TableCell align="center">{convertPrice(row.purchase_price, false, true)}</TableCell>
									)}
									{!permisos?.remove_bene && (
										<TableCell align="center">
											{convertPrice((parseFloat(row.price) - parseFloat(row.purchase_price)), null, true)}
										</TableCell>
									)}

									<TableCell align="center">{row.price}</TableCell>
									<TableCell align="center">
										{convertPrice(row.type == 1 && row.pay == "efectivo" ? row.price : 0, null, true)}
									</TableCell>
									<TableCell align="center">
										{convertPrice(row.type == 0 && row.pay == "efectivo" ? row.price : 0, null, true)}
									</TableCell>
									<TableCell align="center">
										{convertPrice(row.type == 1 && row.pay == "qr" ? row.price : 0, null, true)}
									</TableCell>
									<TableCell align="center">
										{convertPrice(row.type == 0 && row.pay == "qr" ? row.price : 0, null, true)}
									</TableCell>
									<TableCell
										align="center"
										style={{
											backgroundColor: row.pay == "en espera" ? "rgba(255, 0, 250, 0.2)" : "#fff",
										}}>
										{convertPrice(row.type == 1 ? row.price : "-" + row.price, null, true)}
									</TableCell>
								</TableRow>
							))}
					</TableBody>
					<TableFooter>
						{/* FILA DE TOTALES */}
						<TableRow>
							<TableCell align="center" colSpan={3} style={{ fontWeight: "bold" }}>
								TOTAL
							</TableCell>
							{!permisos?.remove_costo && (
								<TableCell align="center" style={{ fontWeight: "bold" }}>
									{convertPrice(totalPc)}
								</TableCell>
							)}
							{!permisos?.remove_bene && (
								<TableCell align="center" style={{ fontWeight: "bold" }}>
									{convertPrice(totalB)}
								</TableCell>
							)}
							<TableCell align="center" style={{ fontWeight: "bold" }}>
								{convertPrice(totalGeneral)}
							</TableCell>
							<TableCell align="center" style={{ fontWeight: "bold" }}>
								{convertPrice(totalEfectivoEntrada)}
							</TableCell>
							<TableCell align="center" style={{ fontWeight: "bold" }}>
								{convertPrice(totalEfectivoSalida)}
							</TableCell>
							<TableCell align="center" style={{ fontWeight: "bold" }}>
								{convertPrice(totalQrEntrada)}
							</TableCell>
							<TableCell align="center" style={{ fontWeight: "bold" }}>
								{convertPrice(totalQrSalida)}
							</TableCell>
							<TableCell align="center" style={{ fontWeight: "bold" }}>
								{convertPrice(totalDeboE)}
							</TableCell>
						</TableRow>
						{/* FILA TOTAL EFECTIVO Y TOTAL QR */}
						<TableRow>
							<TableCell colSpan={permisos?.remove_costo && permisos?.remove_bene ? 4 : 6} style={{ backgroundColor: 'var(--theme-company)' }} />
							<TableCell
								colSpan={2}
								align="center"
								style={{
									fontWeight: "bold",
									backgroundColor: 'var(--theme-company)',
									color: "#fff",
									paddingRight: "1rem",
								}}>
								Total Ef: {convertPrice(totalEfectivoEntrada - totalEfectivoSalida)}
							</TableCell>

							<TableCell
								colSpan={2}
								align="center"
								style={{
									fontWeight: "bold",
									backgroundColor: 'var(--theme-company)',
									color: "#fff",
									paddingLeft: "1rem",
								}}>
								Total Qr: {convertPrice(totalQrEntrada - totalQrSalida)}
							</TableCell>
							<TableCell style={{ backgroundColor: 'var(--theme-company)' }} />
						</TableRow>
					</TableFooter>
				</Table>
			</TableContainer>
		</div>
	);
};
